module.exports = __webpack_public_path__ + "img/diamond-fill.94d6e1df.svg";